import React from "react";
import styled from "styled-components";

import UIButtonPrimary from "components/UI/Button/Primary";

const Wrapper = styled.div`
  align-items: center;
  background: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 60px 0 0 0;

  & > h3 {
    margin: 24px 0;
  }
`;

class ErrorView extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Wrapper>
          <h3>An error has ocurred. Please reload the page</h3>
          <UIButtonPrimary onClick={() => window.location.replace("/")}>
            Reload page
          </UIButtonPrimary>
        </Wrapper>
      );
    }

    return this.props.children;
  }
}

export default ErrorView;
